const ptBR = {
  'common.search': 'Buscar',
  'common.copied': 'Copiado',
  'common.copy': 'Copiar',
  'common.poweredBy': 'Powered by',
  'common.plan': 'Plano',
  'common.banner': 'Banner',
  'common.total': 'Total {value}',
  'common.installmentPrefix': '{count}x de',
  'common.discountCoupon': 'Cupom',
  'common.checkout': 'Checkout',
  'common.tryAgain': 'Tentar novamente',

  'app.loading': 'Carregando o checkout…',
  'app.init.error': 'Erro ao inicializar o checkout:',

  'checkout.title': 'Finalize sua assinatura',
  'checkout.subtitle': 'Preencha os dados para liberar o acesso a {productName}.',
  'checkout.greeting': 'Estamos felizes em te ver, {firstName}',
  'checkout.contactInfo': 'Informações de contato',
  'checkout.contact.namePlaceholder': 'Nome completo',
  'checkout.paymentMethod': 'Método de pagamento',
  'checkout.cardData': 'Dados do cartão',
  'checkout.card.maskPlaceholder': '•••• •••• •••• ••••',
  'checkout.card.expMonth': 'Mês',
  'checkout.card.expYear': 'Ano',
  'checkout.card.cvv': 'CVV',
  'checkout.card.expiryPlaceholder': 'MM/AA',
  'checkout.card.holderName': 'Nome completo do titular do cartão',
  'checkout.document': 'Documento',
  'checkout.document.cpfHolder': 'CPF do titular',
  'checkout.useFilledName': 'Utilizar nome já preenchido',
  'checkout.summary.ariaLabel': 'Resumo da assinatura',
  'checkout.summary.community': 'Comunidade',
  'checkout.summary.availablePlans': 'Planos disponíveis',
  'checkout.summary.chooseAccess': 'Escolha seu acesso',
  'checkout.summary.buying': 'Você está comprando:',
  'checkout.summary.renewal': 'Será renovado em {date}. Você pode cancelar quando quiser.',
  'checkout.theme.enableLight': 'Ativar tema claro',
  'checkout.theme.enableDark': 'Ativar tema escuro',
  'checkout.theme.light': 'Claro',
  'checkout.theme.dark': 'Escuro',
  'checkout.installments.title': 'Parcelamento',
  'checkout.installments.placeholder': 'Número de parcelas',
  'checkout.installments.discount': '{percent}% OFF',
  'checkout.submit.generatePix': 'Gerar código PIX',
  'checkout.submit.buyLifetime': 'Adquirir {productName} (acesso vitalício)',
  'checkout.submit.subscribe': 'Assinar {productName}',
  'checkout.footer.safeTransaction': 'Transação segura e criptografada',
  'checkout.footer.termsPrefix': 'Ao confirmar sua compra, você concorda com os',
  'checkout.footer.terms': 'Termos de Uso do Ginastee',

  'checkout.notFound.eyebrow': 'Checkout indisponível',
  'checkout.notFound.title': 'Comunidade não encontrada',
  'checkout.notFound.description': 'Este link de checkout não corresponde a uma comunidade ativa. Verifique o endereço ou entre em contato com a comunidade.',

  'checkout.paymentsUnavailable.message': 'Os pagamentos para a sua região ainda não estão disponíveis — o responsável pela comunidade precisa concluir a configuração da carteira.',
  'checkout.paymentsUnavailable.action': 'Como configurar',

  'coupon.title': 'Cupom de desconto',
  'coupon.placeholder': 'Digite o cupom',
  'coupon.notFound': 'Cupom não encontrado',

  'pix.title': 'Conclua o pagamento via Pix',
  'pix.instructions': 'Abra um aplicativo em que você tenha o Pix habilitado e escolha a opção "Pagar", em seguida "Ler QR Code"',
  'pix.scanQrCode': 'Escaneie o QR Code abaixo no app do seu banco',
  'pix.qrAlt': 'QR Code Pix',
  'pix.copyCode': 'Ou, se preferir, copie e cole o código abaixo',
  'pix.timeLeft': 'O tempo para você pagar termina em:',
  'pix.realtime': 'Atualizado em tempo real',

  'thanks.confirming.title': 'Confirmando pagamento',
  'thanks.confirming.description': 'Estamos aguardando a confirmação do pagamento antes de liberar o acesso.',
  'thanks.failed.title': 'Pagamento não confirmado',
  'thanks.failed.description': 'Não conseguimos confirmar o pagamento. Tente novamente ou fale com o suporte.',
  'thanks.success.title': 'Parabéns!',
  'thanks.success.subtitle': 'Você assinou {productName}',
  'thanks.success.emailSent': 'Um email foi enviado para você com o link de acesso à plataforma.',
  'thanks.success.emailMissing': 'Ainda não recebeu o email?',
  'thanks.success.emailDelay': 'O email de cadastro geralmente chega em até 5 minutos.',
  'thanks.success.spamSupport': 'Caso este tempo tenha se passado, verifique na caixa de spam, ou envie uma mensagem para o canal de suporte.',
  'thanks.success.supportButton': 'O email ainda não chegou',

  'method.creditCard': 'Cartão de crédito',
  'method.pix': 'PIX',

  'input.fullName.placeholder': 'Digite o nome completo',
  'input.phone.placeholder': 'Número de celular',
  'input.country.searchPlaceholder': 'Buscar país',
  'input.date.label': 'Data',
  'input.date.placeholder': 'dd/mm/aaaa',
  'input.cpf.placeholder': '000.000.000-00',
  'input.money.label': 'Valor',
  'input.money.placeholder': 'R$ 0,00',
  'input.cnpj.label': 'CNPJ',
  'input.cnpj.placeholder': '00.000.000/0000-00',
  'input.email.placeholder': 'email@exemplo.com',
  'input.cardNumber.label': 'Número do cartão',
  'input.cardNumber.placeholder': '0000 0000 0000 0000',

  'address.label': 'Endereço',
  'address.placeholder': 'Busque seu endereço',
  'address.noOptions': 'Nenhum endereço encontrado',
  'address.number.label': 'Número',
  'address.number.placeholder': 'Nº',
  'address.complement.label': 'Complemento',
  'address.complement.placeholder': 'Apto, Bloco...',
  'address.neighborhood.label': 'Bairro',
  'address.zipcode.label': 'CEP',
  'address.zipcode.placeholder': '00000-000',
  'address.city.label': 'Cidade',
  'address.state.placeholder': 'UF',

  'stripe.error.generic': 'Houve um erro ao processar o pagamento, verifique os dados informados e tente novamente',
  'stripe.error.incompleteCard': 'Preencha os dados do cartão para continuar',
  'stripe.error.confirmPayment': 'Houve um erro ao confirmar o pagamento',
  'stripe.submit': 'Confirmar pagamento',

  'payment.error.generic': 'Houve um erro ao processar o pagamento, verifique os dados informados e tente novamente',
  'payment.error.prepare': 'Houve um erro ao preparar o pagamento, verifique os dados informados e tente novamente',
  'payment.error.missingCharge': 'Identificador da cobrança não retornado',
  'payment.error.notApproved': 'Pagamento não aprovado. Verifique os dados do cartão e tente novamente.',

  'validation.cardNumber': 'Corrija o número do cartão',
  'validation.cardExpiration': 'Data de expiração inválida',
  'validation.cardExpired': 'Cartão expirado',
  'validation.cardCvv': 'CVV inválido',
  'validation.cpf': 'CPF inválido',
  'validation.fullName': 'Nome completo inválido',
  'validation.fullNameLettersOnly': 'Nome deve conter apenas letras',
  'validation.emailRequired': 'Email é obrigatório',
  'validation.emailInvalid': 'Email inválido',
  'validation.phoneRequired': 'Telefone é obrigatório',
  'validation.phoneInvalid': 'Telefone inválido',
  'validation.phoneDigits': 'Telefone deve ter 10 ou 11 dígitos',
  'validation.phoneMobileStartsWithNine': 'Celular deve começar com 9',
  'validation.phoneDdd': 'DDD inválido',

  'interval.week.adjective': 'Semanal',
  'interval.month.adjective': 'Mensal',
  'interval.bimonthly.adjective': 'Bimestral',
  'interval.quarterly.adjective': 'Trimestral',
  'interval.semiannual.adjective': 'Semestral',
  'interval.year.adjective': 'Anual',
  'interval.lifetime.adjective': 'Vitalício',
  'interval.week.noun': 'Semana',
  'interval.month.noun': 'Mês',
  'interval.bimonthly.noun': 'Bimestre',
  'interval.quarterly.noun': 'Trimestre',
  'interval.semiannual.noun': 'Semestral',
  'interval.year.noun': 'Ano',
  'interval.lifetime.noun': 'Vitalício',
  'interval.lifetime.access': 'acesso vitalício',
  'interval.period': 'período',

  'month.01': 'Janeiro',
  'month.02': 'Fevereiro',
  'month.03': 'Março',
  'month.04': 'Abril',
  'month.05': 'Maio',
  'month.06': 'Junho',
  'month.07': 'Julho',
  'month.08': 'Agosto',
  'month.09': 'Setembro',
  'month.10Label': 'Outubro',
  'month.11Label': 'Novembro',
  'month.12': 'Dezembro',
} as const;

export default ptBR;
